import { MouseEvent, useCallback } from 'react';
import { useEvent, useUnit } from 'effector-react';
import { getContextMenuPositionByTarget } from '@nx-frontend/shared/ui/context-menu';
import { openModalEvent } from '@nx-frontend/shared/ui/modal';
import { upsertWorkspaceNote } from '@nx-frontend/shared/api/webnotes';
import { $currentWorkspace } from '@nx-frontend/shared/store/current-workspace';
import { MenuItem, MenuItemType, PopupType } from '@nx-frontend/shared/types';

export const useOpenKitchenMenuEmojiDialog = () => {
  const [currentWorkspace] = useUnit([$currentWorkspace]);
  const [openModal] = useEvent([openModalEvent]);

  return useCallback(
    async (menuItem: MenuItem, e: MouseEvent) => {
      openModal({
        content: PopupType.EMOJI,
        showCloseButton: false,
        payload: {
          payloadType: PopupType.EMOJI,
          allowRemove: Boolean(menuItem.icon),
          onApply: (value: string) => {
            upsertWorkspaceNote({
              workspaceId: currentWorkspace.globalId,
              noteId:
                menuItem.type === MenuItemType.NOTE
                  ? menuItem.id.replace('note#', '')
                  : menuItem.id.replace('notesFolder#', ''),
              note: {
                emoji: value,
              },
            });
          },
        },
        position: getContextMenuPositionByTarget(e.target),
        additionalLayoutStyles: 'bg-transparent',
      });
    },
    [currentWorkspace.globalId, openModal]
  );
};
